import React, { useEffect } from 'react';
import useService from '../hooks/useService';
import devices from './../lib/services/devices';
import UPPage from '../components/UPPage';
import DevicesListWrap from '../components/DevicesListWrap';
import { redirect } from '../lib/Utils';
import { LinearProgress } from '@mui/material';

/**
 * The Page of devices
 */
export default function() {
  const { isRequestDone, success, send, response } = useService(devices);

  useEffect(() => {
    send();
  }, [send]);

  useEffect(() => {
    if (isRequestDone && !success) {
      redirect('/auth');
    }
  }, [isRequestDone, success]);

  if (!isRequestDone || !success) {
    return <LinearProgress color="primary" />;
  }

  return (
    <UPPage>
      <DevicesListWrap
        update={send}
        devices={response && response.body ? response.body : []}
      />
    </UPPage>
  );
}
